"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.assign.js");

require("antd/lib/spin/style");

var _spin = _interopRequireDefault(require("antd/lib/spin"));

require("antd/lib/divider/style");

var _divider = _interopRequireDefault(require("antd/lib/divider"));

require("antd/lib/steps/style");

var _steps = _interopRequireDefault(require("antd/lib/steps"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

require("antd/lib/tabs/style");

var _tabs = _interopRequireDefault(require("antd/lib/tabs"));

require("antd/lib/button/style");

var _button = _interopRequireDefault(require("antd/lib/button"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

require("./Wizard.less");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["activeKey", "animated", "asTabs", "bodyStyle", "cancelButtonProps", "cancelButtonText", "children", "clickableSteps", "dividerStyle", "doneButtonProps", "doneButtonText", "enableCancel", "footerExtra", "headerSize", "loading", "nextButtonDisabled", "nextButtonLoading", "nextButtonProps", "nextButtonText", "noStepsProgress", "onCancel", "onFinish", "onStepChange", "onStepChanging", "previousButtonProps", "previousButtonText", "renderWrapper", "saveMode", "showActiveStepTitleOnly", "showCancelButton", "stepsExtra", "stepsProps", "onActiveKeyChange"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @desc Wizard control
 * @param activeKey
 * @param asTabs
 * @param cancelButtonText
 * @param clickableSteps
 * @param doneButtonText
 * @param finishButtonProps
 * @param footerExtra
 * @param loading
 * @param nextButtonDisabled
 * @param nextButtonText
 * @param nextButtonProps
 * @param onCancel
 * @param onFinish
 * @param onStepChange
 * @param onStepChanging
 * @param previousButtonText
 * @param rest
 * @param saveMode
 * @param showActiveStepTitleOnly
 * @param bodyStyle
 * @returns {*}
 * @constructor
 */
function Wizard(_ref, ref) {
  var activeKey = _ref.activeKey,
      animated = _ref.animated,
      asTabs = _ref.asTabs,
      _ref$bodyStyle = _ref.bodyStyle,
      bodyStyle = _ref$bodyStyle === void 0 ? {} : _ref$bodyStyle,
      cancelButtonProps = _ref.cancelButtonProps,
      cancelButtonText = _ref.cancelButtonText,
      children = _ref.children,
      clickableSteps = _ref.clickableSteps,
      dividerStyle = _ref.dividerStyle,
      doneButtonProps = _ref.doneButtonProps,
      doneButtonText = _ref.doneButtonText,
      enableCancel = _ref.enableCancel,
      footerExtra = _ref.footerExtra,
      headerSize = _ref.headerSize,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      nextButtonDisabled = _ref.nextButtonDisabled,
      nextButtonLoading = _ref.nextButtonLoading,
      nextButtonProps = _ref.nextButtonProps,
      nextButtonText = _ref.nextButtonText,
      _ref$noStepsProgress = _ref.noStepsProgress,
      noStepsProgress = _ref$noStepsProgress === void 0 ? false : _ref$noStepsProgress,
      onCancel = _ref.onCancel,
      onFinish = _ref.onFinish,
      onStepChange = _ref.onStepChange,
      onStepChanging = _ref.onStepChanging,
      previousButtonProps = _ref.previousButtonProps,
      previousButtonText = _ref.previousButtonText,
      renderWrapper = _ref.renderWrapper,
      saveMode = _ref.saveMode,
      showActiveStepTitleOnly = _ref.showActiveStepTitleOnly,
      _ref$showCancelButton = _ref.showCancelButton,
      showCancelButton = _ref$showCancelButton === void 0 ? true : _ref$showCancelButton,
      stepsExtra = _ref.stepsExtra,
      _ref$stepsProps = _ref.stepsProps,
      stepsProps = _ref$stepsProps === void 0 ? {} : _ref$stepsProps,
      onActiveKeyChange = _ref.onActiveKeyChange,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (children === undefined) {
    throw new Error('Wizard must have at least 1 step/children (Wizard.Step)');
  }

  var steps = (children.length === undefined ? [children] : children).filter(function (c) {
    return c !== null;
  });

  function getIndexByKey(key) {
    return key ? steps.findIndex(function (s) {
      return s.key === key;
    }) || 0 : 0;
  }

  var _useState = (0, _react.useState)(activeKey),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentKey = _useState2[0],
      setCurrentKey = _useState2[1];

  var _useState3 = (0, _react.useState)(getIndexByKey(activeKey)),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      currentStepIndex = _useState4[0],
      setCurrentStepIndex = _useState4[1];

  var stepRefs = (0, _react.useRef)(steps.map(function () {
    return (0, _react.createRef)();
  }));
  (0, _react.useEffect)(function () {
    stepRefs.current = steps.map(function () {
      return (0, _react.createRef)();
    });
  }, [steps]);
  (0, _react.useEffect)(function () {
    setCurrentStepIndex(getIndexByKey(activeKey));
    setCurrentKey(activeKey); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);

  var selectStep = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(index, forcedCurrentIndex) {
      var curr, newStepIndex, continues;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              curr = forcedCurrentIndex !== undefined ? forcedCurrentIndex : currentStepIndex;
              newStepIndex = index;

              if (!(saveMode ? newStepIndex !== curr : newStepIndex !== curr && (newStepIndex === curr + 1 || newStepIndex < curr))) {
                _context.next = 21;
                break;
              }

              _context.t0 = !onStepChanging;

              if (_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t1 = onStepChanging;

              if (!_context.t1) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return onStepChanging(newStepIndex, curr);

            case 9:
              _context.t1 = _context.sent;

            case 10:
              _context.t0 = _context.t1;

            case 11:
              continues = _context.t0;

              if (!(continues === undefined || continues)) {
                _context.next = 18;
                break;
              }

              _context.next = 15;
              return setCurrentStepIndex(newStepIndex);

            case 15:
              setCurrentKey(steps[newStepIndex].key);
              onStepChange && onStepChange(newStepIndex, curr);
              onActiveKeyChange && onActiveKeyChange(steps[newStepIndex].key);

            case 18:
              return _context.abrupt("return", continues);

            case 21:
              return _context.abrupt("return", false);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function selectStep(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getStepProps = function getStepProps() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : currentStepIndex;
    return steps[index].props || {};
  };

  var handleNextClick = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return selectStep(currentStepIndex + 1);

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleNextClick() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handlePreviousClick = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return selectStep(currentStepIndex - 1);

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handlePreviousClick() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleFinishClick = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              onFinish && onFinish(currentStepIndex);

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleFinishClick() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleStepClick = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(stepIndex) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!clickableSteps) {
                _context5.next = 3;
                break;
              }

              _context5.next = 3;
              return selectStep(stepIndex);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleStepClick(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleTabClick = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(key) {
      var stepIndex;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              stepIndex = steps.findIndex(function (s) {
                return s.key === key;
              });
              _context6.next = 3;
              return selectStep(stepIndex);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function handleTabClick(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleCancelClick = function handleCancelClick() {
    onCancel && onCancel();
  };

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      //exposing methods to parent through ref
      getCurrentStepRef: function getCurrentStepRef() {
        return stepRefs.current[currentStepIndex].current;
      }
    };
  });
  var actions = saveMode ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showCancelButton ? /*#__PURE__*/_react.default.createElement(_button.default, Object.assign({
    className: "Wizard_button-cancel",
    disabled: nextButtonLoading,
    onClick: handleCancelClick
  }, cancelButtonProps), cancelButtonText || 'Cancel') : null, /*#__PURE__*/_react.default.createElement(_button.default, Object.assign({
    className: "Wizard_button-submit",
    type: "primary",
    htmlType: "submit",
    loading: nextButtonLoading || getStepProps().loading,
    disabled: nextButtonDisabled || getStepProps().nextButtonDisabled,
    onClick: handleFinishClick
  }, doneButtonProps), doneButtonText || 'Save')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentStepIndex === 0 && enableCancel ? /*#__PURE__*/_react.default.createElement(_button.default, Object.assign({
    className: "Wizard_button-cancel",
    disabled: nextButtonLoading,
    onClick: handleCancelClick
  }, cancelButtonProps), cancelButtonText || 'Cancel') : null, currentStepIndex > 0 ? /*#__PURE__*/_react.default.createElement(_button.default, Object.assign({
    className: "Wizard_button-previous",
    disabled: nextButtonLoading,
    onClick: handlePreviousClick
  }, previousButtonProps), previousButtonText || 'Back') : null, currentStepIndex < steps.length - 1 ? /*#__PURE__*/_react.default.createElement(_button.default, Object.assign({
    key: "wizard-submit-button-".concat(currentStepIndex),
    className: "Wizard_button-next",
    type: "primary",
    htmlType: animated ? 'button' : 'submit',
    loading: nextButtonLoading || getStepProps().loading,
    disabled: nextButtonDisabled || getStepProps().nextButtonDisabled,
    onClick: handleNextClick
  }, nextButtonProps), nextButtonText || 'Continue') : null, currentStepIndex === steps.length - 1 ? /*#__PURE__*/_react.default.createElement(_button.default, Object.assign({
    className: "Wizard_button-submit",
    type: "primary",
    htmlType: "submit",
    loading: nextButtonLoading || getStepProps().loading,
    disabled: nextButtonDisabled || getStepProps().nextButtonDisabled,
    onClick: handleFinishClick
  }, doneButtonProps), doneButtonText || 'Finish') : null); // resolve header size and style

  var hSize = headerSize || (stepsProps && stepsProps.direction === 'vertical' ? 180 : 35);
  var hStyle = stepsProps && stepsProps.direction === 'vertical' ? {
    width: "".concat(hSize, "px")
  } : {
    height: "".concat(hSize, "px")
  };
  var hStyleFromParams = stepsProps.style;
  var paddingOffset = 20;
  var bStyle = stepsProps && stepsProps.direction === 'vertical' ? {
    width: "calc(100% - ".concat(hSize + paddingOffset, "px)")
  } : {};

  var content = /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading
  }, /*#__PURE__*/_react.default.createElement("div", Object.assign({
    className: (0, _classnames.default)('Wizard', {
      'Wizard--vertical-steps': stepsProps && stepsProps.direction === 'vertical'
    })
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "Wizard-step-header"
  }, asTabs ? /*#__PURE__*/_react.default.createElement(_tabs.default, {
    activeKey: currentKey,
    onTabClick: handleTabClick
  }, steps.map(function (step) {
    return /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      key: step.key,
      tab: step.props.title
    });
  })) : /*#__PURE__*/_react.default.createElement(_steps.default, Object.assign({
    current: currentStepIndex,
    style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, hStyle), hStyleFromParams)
  }, stepsProps), steps.map(function (step, stepIndex) {
    var _step$props = step.props,
        title = _step$props.title,
        subTitle = _step$props.subTitle,
        headerProps = _step$props.headerProps,
        icon = _step$props.icon;
    var status;

    if (noStepsProgress) {
      status = currentStepIndex === stepIndex ? 'process' : 'wait';
    }

    return /*#__PURE__*/_react.default.createElement(_steps.default.Step, Object.assign({
      className: (0, _classnames.default)('Wizard-step-header_item', {
        // 'Wizard-step-header_item--active':
        //     showActiveStepTitleOnly &&
        //     currentStepIndex === stepIndex,
        'Wizard-step-header_item--no-progress': noStepsProgress && currentStepIndex !== stepIndex,
        'Wizard-step-header_item--clickable': clickableSteps
      }),
      status: status,
      key: step.key,
      title: /*#__PURE__*/_react.default.createElement("div", null, showActiveStepTitleOnly && currentStepIndex === stepIndex || !showActiveStepTitleOnly ? title : ''),
      subTitle: showActiveStepTitleOnly && currentStepIndex === stepIndex || !showActiveStepTitleOnly ? subTitle : '',
      onClick: function onClick() {
        return handleStepClick(stepIndex);
      },
      icon: icon
    }, headerProps));
  })), stepsExtra ? /*#__PURE__*/_react.default.createElement("div", {
    className: "Wizard_steps-extra"
  }, stepsExtra(currentKey, currentStepIndex)) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "Wizard-step-body",
    style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, bStyle), bodyStyle)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Wizard-step-content"
  }, animated ? /*#__PURE__*/_react.default.createElement(_tabs.default, {
    activeKey: "".concat(currentStepIndex),
    renderTabBar: function renderTabBar() {
      return /*#__PURE__*/_react.default.createElement("div", null);
    },
    animated: true
  }, steps.map(function (step, idx) {
    return /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      tab: idx,
      key: "".concat(idx)
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: stepRefs.current[idx]
    }, step));
  })) : /*#__PURE__*/_react.default.createElement("div", {
    ref: stepRefs.current[currentStepIndex]
  }, getStepProps().children)), /*#__PURE__*/_react.default.createElement(_divider.default, {
    style: dividerStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "Wizard-step-footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Wizard-step-footer-extra"
  }, footerExtra, getStepProps().footerExtra), /*#__PURE__*/_react.default.createElement("div", {
    className: "Wizard-step-actions"
  }, actions)))));

  if (renderWrapper) {
    return renderWrapper(content);
  } else {
    return content;
  }
}

var ForwardedWizard = (0, _react.forwardRef)(Wizard);

ForwardedWizard.Step = function (_ref8) {
  var children = _ref8.children,
      footerExtra = _ref8.footerExtra,
      headerProps = _ref8.headerProps,
      loading = _ref8.loading,
      nextButtonDisabled = _ref8.nextButtonDisabled;
  return /*#__PURE__*/_react.default.createElement("div", null, children);
};

var _default = ForwardedWizard;
exports.default = _default;